"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AstNode = void 0;
const constant_1 = require("../constant");
/**
 * Represents a node in the Abstract Syntax Tree (AST).
 */
class AstNode {
    /**
     * Determines if this node is conditional.
     * @returns {boolean} True if the node is conditional; otherwise, false.
     */
    isConditional() {
        return !!this.condition && !!this.isFalse && !!this.isTrue;
    }
    /**
     * Determines if this node represents a value.
     * @returns {boolean} True if the node is a value; otherwise, false.
     */
    isValue() {
        return this.value != undefined;
    }
    /**
     * Determines if this node is a comparison operator.
     * @returns {boolean} True if the node is a comparison; otherwise, false.
     */
    isComparison() {
        return !!this.isComparisonOperator();
    }
    /**
     * Determines if this node is a field.
     * @returns {boolean} True if the node is a field; otherwise, false.
     */
    isField() {
        return !!this.fieldName;
    }
    /**
     * Determines if this node is a generic node.
     * @returns {boolean} True if the node is a node; otherwise, false.
     */
    isNode() {
        return (!this.isValue() &&
            !this.isField() &&
            !this.isComparison() &&
            !this.isConditional());
    }
    /**
     * Checks if the operator is a comparison operator.
     * @returns {boolean} True if the operator is a comparison operator; otherwise, false.
     */
    isComparisonOperator() {
        if (constant_1.ComparisonOperator.includes(this.operator))
            return true;
        return false;
    }
}
exports.AstNode = AstNode;
